import { createAsyncThunk } from '@reduxjs/toolkit';
import { updatePaidUser } from '../../api/paidUsers';
import toast from 'react-hot-toast';
import * as authApi from '../../api/auth.js';

export const login = createAsyncThunk(
  'auth/login',
  async (userData, thunkAPI) => {
    try {
      const promise = authApi.login(userData);

      const response = await toast.promise(promise, {
        loading: 'Wait a minute. You are login in',
        success: 'Congratulations! Your profile is online now!',
        error: 'Ups! Something went wrong.',
      });

      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const refresh = createAsyncThunk('auth/refresh', async (_, thunkAPI) => {
  try {
    const response = await authApi.refresh();
    return response;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.message);
  }
});

export const logOut = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  try {
    const response = await authApi.logout();
    return response;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.message);
  }
});

export const updateUserInfo = createAsyncThunk(
  'auth/updateUser',
  async (userData, thunkAPI) => {
    try {
      const response = await updatePaidUser(userData.data, userData.userId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
